import { fields, createSchema, validate as _validate } from '..';

const { email, optionalFiled, requiredText } = fields;

const volunteer = createSchema({
  name: optionalFiled,
  email,
  question: requiredText,
});

const validate = (data) => _validate(volunteer, data);

export default validate;
